<!-- =========================================================================================
    File Name: LoginCbs.vue
    Description: Login CBS Page

========================================================================================== -->
<i18n src="@/locales/components/LoginTranslate.json"></i18n>

<template>
	<div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
		<div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
			<vx-card>
				<div slot="no-body" class="full-page-bg-color">
					<div class="vx-row no-gutter justify-center items-center">
						<div class="vx-col hidden lg:block lg:w-1/2">
							<img src="@/assets/images/pages/login/cbs/login.svg" alt="login" class="mx-auto" />
						</div>

						<div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
							<div class="p-6 md:p-8 login-tabs-container">
								<div class="vx-card__title mb-8">
									<h4 class="mb-4">{{ $t("Welcome") }}</h4>
									<p>{{ $t("PleaseLoginToYourAccount") }}</p>
								</div>

								<login-jwt></login-jwt>
							</div>
						</div>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
</template>

<script>
import LoginJwt from "./LoginJWT.vue";

export default {
	components: {
		LoginJwt
	}
};
</script>

<style lang="scss">
.login-tabs-container {

	.con-tab {
		padding-bottom: 14px;
	}

	.con-slot-tabs {
		margin-top: 1rem;
	}
}
</style>
